import { useDispatch, useSelector } from 'react-redux'
import { DentalsDisplay } from 'Ui/Components/DentalsDisplay'
import 'Application/Templates/Css/Assets/Logo.css'
import { ColorRange } from 'Ui/Components/ColorRange'
import FullscreenComponent from 'Ui/Components/Fullscreen'

import { useInformation } from './hooks/useInformation';
import { CompanyLogo } from './components/information/CompanyLogo';
import { PatientResume } from './components/information/PatientResume';
import { ViewModeSelector } from './components/information/ViewModeSelector';
import { ComparativeVersionSelector } from './components/information/ComparativeVersionSelector';
import { ActionsPanel } from './components/information/ActionsPanel';

/*****************************************************************
 * Main information
 * ***************************************************************/

export const Informations = (props) => {
    const {
        passive,
        onEditMode,
        deniedServices,
        viewerType,
        versions,
        viewportMode,
        selectedVersion,
        currentValue,
        currentLeftValue,
        logoUrl,
        getAnonymous,
        metas,
        isConnected,
        hasChanges,
        handleViewportChange,
        handleComparativeVersionChange,
        handleVersionChange,
        handleEnterEdition,
        handleSaveAndExit,
        AnimationReducer,
        setOnEditMode,
    } = useInformation(props);

    const dispatch = useDispatch();
    const bypassAccess = useSelector((state) => state.UserReducer.bypassAccess);

    const isSceneLoaded = AnimationReducer.loaded;
    const isAdvancedViewer = viewerType !== 'simple';
    const effectiveDeniedServices = bypassAccess ? [] : deniedServices;
    const isTitleBlockDenied = effectiveDeniedServices.includes('titleBlock');
    const isLogoDenied = effectiveDeniedServices.includes('logo');

    const headerIsHidden = !isSceneLoaded;
    const shouldShowCompanyLogo = !isLogoDenied;

    const shouldShowPatientResume = !isTitleBlockDenied && !onEditMode;
    const shouldShowDentalsDisplay = !passive;

    return (
        <>
            <nav id="ViewportHeader" className={headerIsHidden ? "viewport-header-hidden" : null}>
                <div className="vh-left hide-mobile">
                    <div className="glass-panel">
                        {shouldShowCompanyLogo && <CompanyLogo url={logoUrl} />}
                        {isAdvancedViewer && <ViewModeSelector passive={passive} onEditMode={onEditMode} viewportMode={viewportMode} handleViewportChange={handleViewportChange} />}
                        {isAdvancedViewer && <ComparativeVersionSelector passive={passive} viewportMode={viewportMode} deniedServices={effectiveDeniedServices} versions={versions} currentLeftValue={currentLeftValue} handleComparativeVersionChange={handleComparativeVersionChange} />}
                    </div>
                </div>

                {shouldShowPatientResume && (
                    <div className="vh-center">
                        <div className="glass-panel">
                            <PatientResume metas={metas} isConnected={isConnected} getAnonymous={getAnonymous} />
                        </div>
                    </div>
                )}

                <div className="vh-right">
                    <div className="glass-panel">
                        {isAdvancedViewer && (
                            <>
                                <ColorRange />
                                <ActionsPanel
                                    selectedVersion={selectedVersion}
                                    viewportMode={viewportMode}
                                    onEditMode={onEditMode}
                                    passive={passive}
                                    hasChanges={hasChanges}
                                    handleSaveAndExit={handleSaveAndExit}
                                    dispatch={dispatch}
                                    setOnEditMode={setOnEditMode}
                                    deniedServices={effectiveDeniedServices}
                                    versions={versions}
                                    currentValue={currentValue}
                                    handleVersionChange={handleVersionChange}
                                    handleEnterEdition={handleEnterEdition}
                                    logoUrl={logoUrl}
                                />
                                {shouldShowDentalsDisplay && <DentalsDisplay onEditMode={onEditMode} />}
                            </>
                        )}
                    </div>
                </div>
            </nav>
        </>
    );
}
